module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min-400x263.ed082c75.jpg";